import type { Source } from "@/types/models"
import SourceForm from "./Form"

interface Props {
  source: Source
  errors?: Record<string, string[]>
}

export default function EditSource({ source, errors }: Props) {
  return <SourceForm source={source} errors={errors} />
}
